function focusInput(defaultText, inputElement) {
	inputElement.style.color = '#000000';
	if (inputElement.value==defaultText) {
		inputElement.value = '';
	}
}
function blurInput(defaultText, inputElement) {
	inputElement.style.color = '#4B4B4B';
	if (inputElement.value.length<1) {
		inputElement.value = defaultText;
	}
}
